import type { sortByType, sortDirectionType } from 'customTypes/search';

export const getSearchCoinList = async (
	query: string,
	sortBy: sortByType,
	limit: number,
	direction: sortDirectionType,
) => {
	try {
		const res = await fetch(
			`/api/coin-data/search?query=${query}&sort=${sortBy}&limit=${limit}&direction=${direction}`,
		);
		return await res.json();
	} catch (error) {
		console.error(error);
	}
};
